import { useConfirm } from 'hooks/useDialog'
import { useCallback } from 'react'
import { useFormContext } from 'react-hook-form'
import { isEmpty } from 'utils/utils'

export default (setIdx: (idx: number) => void) => {
  const confirm = useConfirm()
  const { formState } = useFormContext()

  return useCallback(
    (idx: number) => {
      if (isEmpty(formState.dirtyFields)) {
        setIdx(idx)
        return
      }

      confirm({
        message: [
          'このページから移動しますか？',
          '入力したデータは保存されません。',
        ],
        onConfirm: () => {
          setIdx(idx)
        },
      })
    },
    [setIdx, formState, confirm],
  )
}
